import { cn } from '@/frontend/utils'

export const calendarClassNames = {
  months: 'space-y-4',
  month_grid: 'border-separate border-spacing-x-2 lg:border-spacing-x-4 border-spacing-y-2',

  weekday: 'w-8 text-sm leading-5 font-normal text-contentTertiary',
  week: 'h-8',

  day: 'relative group text-center text-contentPrimary p-0',
  day_button: cn(
    'w-8 h-8 rounded-full relative z-10',
    'after:absolute after:inset-0 after:bg-backgroundHoverOverlay after:opacity-0 after:rounded-full',
    'enabled:hover:after:opacity-100 disabled:cursor-default'
  ),

  today:
    'rounded-full !text-contentNavyAlgo outline outline-backgroundBlue outline-offset-[-1px] hover:outline-borderHoverOverlay',
  selected:
    'rounded-full bg-backgroundInversePrimary [&_button]:text-white dark:[&_button]:text-black outline-none',

  outside: 'text-contentTertiary',
  disabled: 'text-contentPrimary opacity-50',

  range_middle: cn(
    'relative !bg-transparent [&_button]:!text-contentPrimary',
    'before:absolute before:inset-y-0 before:-left-1.5 lg:before:-left-4 before:-right-1.5 lg:before:-right-4 before:bg-backgroundColorHover before:z-0',
    // round row end
    'first:before:rounded-l-full first:before:left-0',
    'last:before:rounded-r-full last:before:right-0'
  ),

  range_start: cn(
    'relative !bg-transparent',
    'before:absolute before:inset-y-0 before:left-0 before:-right-1.5 lg:before:-right-4 before:bg-backgroundColorHover before:rounded-l-full before:z-0',
    // force round if start is at the end of a row
    'last:before:right-0 last:before:rounded-r-full',
    '[&_button]:bg-backgroundInversePrimary [&_button]:!text-white dark:[&_button]:!text-black'
  ),

  range_end: cn(
    'relative !bg-transparent',
    'before:absolute before:inset-y-0 before:-left-1.5 lg:before:-left-4 before:right-0 before:bg-backgroundColorHover before:rounded-r-full before:z-0',
    // force round if end is at the start of a row
    'first:before:left-0 first:before:rounded-l-full',
    '[&_button]:bg-backgroundInversePrimary [&_button]:!text-white dark:[&_button]:!text-black'
  ),

  caption_label: 'text-center w-full text-base leading-6 font-normal text-contentPrimary mt-2.5'
}

export const calendarModifiersClassNames = {
  available:
    'rounded-full bg-backgroundBlue [&_button]:text-contentNavyAlgo [&[data-outside="true"]]:opacity-60'
}
